<template>
    <div class="container" v-loading="tableing">
        <div class="header">
            <el-button class="exit" size="mini" @click="exit()"> 退出 </el-button>
        </div>
        <div class="main">
            <div class="main-clone">
                <!-- 系统自检 -->
                <div class="systemSelfCheck" v-loading="checkGo" element-loading-text="系统自检中..." element-loading-background="#F9FCFF">
                    <div class="systemSelfCheck-box">
                        <div class="checking">
                            <p class="impTitle">系统自检</p>
                            <div v-if="isTimeOk||isBrower">
                                <p class="imptext" v-if="isTimeOk"><i class="el-icon-warning" style="color:red;font-size:18px;"></i> 您的电脑系统时间与北京时间不符，请调整系统时间为北京时间
                                    <el-link type="primary" @click="refreshTimeStatus" :disabled="checkGo">重新检测</el-link>
                                </p>
                                <p class="imptext">浏览器版本：<b>{{browerInfo}}</b></p>
                                <p class="imptext red" v-if="isBrower"><i class="el-icon-warning" style="color:red;font-size:18px;"></i> 系统检测到您的浏览器版本不是校方指定版本，建议使用校方推荐浏览器</p>
                            </div>
                            <div class="checkOk" v-else>
                                <p class="imptext" style="font-size:20px">系统自检已完成</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 录音检测 -->
                <div class="main-tape" v-if="false">
                    <div class="detection" v-if="!luYingUrl">
                        <div class="detection-icon"></div>
                        <div class="detection-body">
                            <ul>
                                <li>录音检测</li>
                                <li>点击开始检测后，对麦克风朗读：录音检测。完成后点击完成结束录音，点击声音检测的音频确认听到录音后开始考试</li>
                            </ul>
                        </div>
                        <div class="detection-btn">
                            <el-button class="goCheck" @click="goCheck"> 开始检测 </el-button>
                        </div>
                    </div>
                    <div class="detection-2" v-else>
                        <div class="detection-2-icon"></div>
                        <div class="detection-2-body">
                            <ul>
                                <li>录音检测</li>
                                <li>点击开始检测后，对麦克风朗读：录音检测。完成后点击完成结束录音，点击声音检测的音频确认听到录音后开始考试</li>
                                <li>
                                    <el-button class="goCheck-2" @click="goCheck"> 开始检测 </el-button>
                                </li>
                            </ul>
                        </div>
                        <div class="detection-2-icon-2"></div>
                        <div class="detection-2-body-2">
                            <ul>
                                <li>声音检测</li>
                                <li>点击语音确认听到声音后进入考试</li>
                                <li>
                                    <audio-style 
                                        style="width:140px;float:left;margin-top: 48px;"
                                        ref="audioRef"
                                        @startPlaying="startPlaying"
                                        @endPlaying="endPlaying"
                                        @getPlays="getPlays"
                                        :audioUrl="luYingUrl"
                                        class="audioCom"
                                    ></audio-style>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- 播放声音检测 -->
                <div class="main-receiver">
                    <div class="receiver-box">
                        <div class="receiver-box-icon"></div>
                        <div class="receiver-box-body">
                            <ul>
                                <li>音频检测</li>
                                <li>点击音频查看是否可以正常播放和声音是否正常</li>
                                <li>
                                    <audio-style 
                                        style="width:220px;height:45px;float:left"
                                        ref="audioRef2"
                                        @startPlaying="audio_startPlaying"
                                        @endPlaying="audio_endPlaying"
                                        @getPlays="audio_getPlays"
                                        :styleText="'点击播放/暂停'"
                                        :audioUrl="testAudioUrl"
                                        class="audioCom2"
                                    ></audio-style>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="goExamBox">
                    <el-button class="upSub" @click="lastQuestion()"> 下一步 </el-button>
                </div>
            </div>
        </div>

        <el-dialog
            class="equipmentInspection"
            title="考前设备检测"
            :visible.sync="equipmentDialog"
            :show-close="false"
            width="30%"
            center>
            <div class="bgRecarding"></div>
            <span class="bgRecarding-ing"><b>录音中...</b></span>
            <span slot="footer" class="dialog-footer">
                <el-button type="success" class="sucRecard" @click="submitRecording()"> 完成录音 </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import recording from '../../lib/recording'
import systemCheck from '../../lib/systemCheck'
import audioStyle from '../../components/audioStyle'
import { getDateNow } from '../../lib/youxunAPI';
import os from '../../lib/oss'
import util from '../../lib/util'
    export default {
        name:"mkfDetection",
        data() {
            return {
                tableing:false,
                equipmentDialog:false,
                list:[],
                timeLz:0,
                interval: '',
                luYingUrl:'',
                testAudioUrl:require('../../../static/music/guoge.mp3'),
                isAudioIng:true,
                isTimeOk:false,
                isBrower:false,
                checkGo:false,
                browerInfo:'',
                time25:null,
            }
        },
        components:{
            audioStyle
        },
        watch: {},
        computed:{},
        created(){},
        beforeDestroy() {
            this.time25 && clearTimeout(this.time25)
        },
        mounted(){
            let that = this
            that.checkGo = true
            that.refreshTimeStatus()
            that.browerInfoJuck()
            that.time25 = window.setTimeout(function(){
                that.checkGo = false    
            },2500)
        },
        methods:{
            timeCheckShow(){
                let poorTime;
                this.nowTimePccheck()
                this.$nextTick(()=>{
                    poorTime = window.localStorage.getItem('poorVal')
                    if(Math.abs(poorTime)>0)
                    this.isTimeOk = true
                })
            },
            // 当前时间检测
            nowTimePccheck(){
                let pcTime = new Date().getTime();
                let nTime = Number.parseInt(pcTime) + Number.parseInt(window.localStorage.getItem('poorVal'))
                let poorTime = nTime - pcTime;
                let poorVal = 0;
                if(Math.abs(poorTime)>=60000){
                    poorVal = poorTime
                }else{ poorVal = 0 }
                localStorage.setItem('poorVal',poorVal);
            },
            browerInfoJuck(){
                let temps;
                this.browerInfo = systemCheck.getExplorerVersion()
                temps = this.browerInfo.split(' ')
                if(temps[0]=="chrome"&&Number(temps[1].split('.')[0])>=70)
                    this.isBrower = false
                else
                    this.isBrower = true
            },
            refreshTimeStatus(){
                let that = this
                that.checkGo = true
                getDateNow(function(response){
                    that.time25 = window.setTimeout(function(){
                        that.checkGo = false  
                    },1500)
                    if(response.data&&response.data.code == 0){
                        let nTime = response.data.data.sysTime
                        let pcTime = new Date().getTime();
                        let poorTime = nTime - pcTime;
                        let poorVal = 0;
                        if(Math.abs(poorTime)>=60000){
                            poorVal = poorTime
                        }else{ poorVal = 0 }
                        localStorage.setItem('poorVal',poorVal);
                        if(Math.abs(poorVal)==0)
                        that.isTimeOk = false
                        else
                        that.isTimeOk = true    
                    }else{
                        that.timeCheckShow()
                    }
                })
            },
            goCheck(){
                let that = this
                that.luYingUrl = ''
                that.mouseStart(1000,-1)
            },
            mouseStart (plays,nPlays=-1) {
                if(plays>0||nPlays==-1){
                    this.clearTimer()
                    this.timeLz = 0
                    recording.get((rec) => {
                        // 要获取浏览器的麦克风权限
                        if (rec) {
                            if (this.flag) {
                                this.mouseEnd()
                                this.flag = false
                            } else {
                                this.equipmentDialog = true
                                this.recorder = rec
                                this.interval = setInterval(() => {
                                    this.timeLz++
                                    this.recorder.start()
                                }, 1000)
                            }
                        }else{
                            this.$message({showClose: true,message: '请设置您的麦克风访问权限'});
                        }
                    })
                }else{
                    this.$message({showClose: true,message: `该音频只能播放${nPlays}次`})
                }
            },
            mouseEnd () {
                let that = this
                that.clearTimer()
                if (that.recorder) {
                    that.recorder.stop()
                    let bold = that.recorder.getBlob()
                    let files = new File([bold], `recording${Date.parse(new Date())}.mp3`, {type: 'audio/mp3', lastModified: Date.now()})
                    os.uploadHttp(files,function(e,file){
                        that.equipmentDialog = false
                        // console.log(e)
                        that.luYingUrl = e
                    })
                }
            },
            submitRecording(){
                this.mouseEnd()
            },
            clearTimer () {
                if (this.interval) {
                    this.timeLz = 0
                    clearInterval(this.interval)
                }
            },
            getPlays(){
                this.$refs.audioRef.endAudio();
                this.$refs.audioRef.fatherPlay(1000,-1);
            },
            startPlaying(){},
            endPlaying(){},
            lastQuestion(){
                let href_ = window.location.href.split('#/')[1]
                let lv = href_.indexOf('?')!=-1? href_.split('?')[0]:''
                let menuListArr = this.$route.query.menuList.split(',')
                let menuListLoc = menuListArr.indexOf(String(util.menuListGet().indexOf(lv)))
                this.$router.push({
                    path: `/${util.menuListGet()[menuListArr[menuListLoc+1]]}`,
                    query: {
                        bId:this.$route.query.bId,
                        paperName:this.$route.query.paperName,
                        userSignId:this.$route.query.userSignId,
                        ticketNum:this.$route.query.ticketNum,
                        idName:this.$route.query.idName,
                        idCardNo:this.$route.query.idCardNo,
                        youXunExamId:this.$route.query.youXunExamId,
                        youXunExamNum:this.$route.query.youXunExamNum,
                        examStartDate:this.$route.query.examStartDate,
                        examEndDate:this.$route.query.examEndDate,
                        examStatus:this.$route.query.examStatus,
                        examStartDateVal:this.$route.query.examStartDateVal,
                        examEndDateVal:this.$route.query.examEndDateVal,
                        examMin:this.$route.query.examMin,
                        personNum:this.$route.query.personNum,
                        reviewType:this.$route.query.reviewType,
                        menuList:this.$route.query.menuList,
                    }
                }) 
            },
            exit(){
                this.$confirm('请问是否退出当前考试？','确认信息',{
                    distinguishCancelAndClose:true,
                    confirmButtonText:'是',
                    cancelButtonText:'否',
                })
                .then(()=>{
                    if(sessionStorage.getItem('orgId')){//测评
                        this.$router.push({
                            path: `/${sessionStorage.getItem('orgId')}/examList`,
                        })
                    }else{
                        this.$router.push({
                            path: '/myExamList'
                        })
                    }
                })
                .catch((action)=>{})
            },
            audio_getPlays(){
                this.isAudioIng = this.$refs.audioRef2.judgePaying()
                if(this.isAudioIng){
                    this.$refs.audioRef2.fatherPlay(1000,-1);
                }
                else{
                    this.$refs.audioRef2.endAudio();
                    this.isAudioIng = true
                }
            },
            audio_startPlaying(){
                console.log('开始播放')
            },
            audio_endPlaying(){
                console.log('播放结束')
            },
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        border-bottom: 1px solid #EDEEED;
        .exit{
            background-color: #31C4FE;
            border: none;
            font-size: 15px;
            width: 74px;
            height: 32px;
            color: #fff;
            position: absolute;
            top: 15px;
            right: 3%;
            img{
                height: 10px;
            }
        }
    }
    .main{
        position: absolute;
        top: 75px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        .main-clone{
            height:100%;
            width: 100%;
            overflow: hidden;
            position: relative;
            .main-tape{
                // position: absolute;
                // left: 7%;
                // top: 10%;
                width: 86%;
                height: 30%;
                margin: 0 auto;
                margin-top: 2%;
                .detection{
                    width: 100%;
                    height: 100%;
                    border-radius: 3px;
                    background-color: #F9FCFF;
                    .detection-icon{
                        height: 100%;
                        width: 25%;
                        background-image: url('../../../static/images/mkf.png');
                        background-size: 60%;
                        background-position: 50%;
                        background-repeat: no-repeat;
                        float: left;
                    }
                    .detection-body{
                        float: left;
                        height: 100%;
                        width: 50%;
                        position: relative;
                        ul{
                            position: absolute;
                            left: 0;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            margin: auto;
                            width: 83%;
                            height: 120px;
                            li{
                                font-size: 21px;
                                text-align: left;
                            }
                            li:nth-child(1){
                                color: #0900AA;
                            }
                            li:nth-child(2){
                                font-size: 20px;
                            }
                        }
                    }
                    .detection-btn{
                        height: 100%;
                        width: 25%;
                        float: left;
                        position: relative;
                        .goCheck{
                            position: absolute;
                            left: 0;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            height: 40px;
                            margin: auto;
                            width: 125px;
                            background-color: #1CC966;
                            font-size: 17px;
                            line-height: 17px;
                            color: #fff;
                        }
                    }
                }
                .detection-2{
                    width: 100%;
                    height: 100%;
                    border-radius: 3px;
                    background-color: #F9FCFF;
                    .detection-2-icon{
                        height: 100%;
                        width: 15%;
                        background-image: url('../../../static/images/mkf.png');
                        background-size: 50%;
                        background-position: 70% 50%;
                        background-repeat: no-repeat;
                        float: left;
                    }
                    .detection-2-body{
                        float: left;
                        height: 100%;
                        width: 33%;
                        margin-right: 2%;
                        position: relative;
                        ul{
                            position: absolute;
                            left: 0;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            margin: auto;
                            width: 90%;
                            height: 125px;
                            li{
                                font-size: 18px;
                                text-align: left;
                            }
                            li:nth-child(1){
                                color: #0900AA;
                            }
                            li:nth-child(2){
                                font-size: 14px;
                            }
                            li:nth-child(3){
                                .goCheck-2{
                                    width: 125px;
                                    background-color: #1CC966;
                                    font-size: 15px;
                                    color: #fff;
                                    padding: 8px 20px;
                                    margin-top: 8px;
                                }
                            }
                        }
                    }
                    .detection-2-icon-2{
                        height: 100%;
                        width: 15%;
                        background-image: url('../../../static/images/checksy.png');
                        background-size: 50%;
                        background-position: 70% 50%;
                        background-repeat: no-repeat;
                        float: left;
                    }
                    .detection-2-body-2{
                        float: left;
                        height: 100%;
                        width: 30%;
                        position: relative;
                        ul{
                            position: absolute;
                            left: 0;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            margin: auto;
                            width: 90%;
                            height: 125px;
                            li{
                                font-size: 18px;
                                text-align: left;
                            }
                            li:nth-child(1){
                                color: #0900AA;
                            }
                            li:nth-child(2){
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
            .main-receiver{
                // position: absolute;
                // left: 7%;
                // top: 45%;
                width: 86%;
                height: 30%;
                margin: 0 auto;
                margin-top: 2%;
                .receiver-box{
                    width: 100%;
                    height: 100%;
                    border-radius: 3px;
                    background-color: #F9FCFF;
                    .receiver-box-icon{
                        height: 100%;
                        width: 25%;
                        background-image: url('../../../static/images/checksy.png');
                        background-size: 60%;
                        background-position: 50%;
                        background-repeat: no-repeat;
                        float: left;
                    }
                    .receiver-box-body{
                        float: left;
                        height: 100%;
                        width: 50%;
                        position: relative;
                        ul{
                            position: absolute;
                            left: 0;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            margin: auto;
                            width: 83%;
                            height: 120px;
                            li{
                                font-size: 21px;
                                text-align: left;
                            }
                            li:nth-child(1){
                                color: #0900AA;
                            }
                            li:nth-child(2){
                                font-size: 14px;
                            }
                            li:nth-child(3){
                                margin-top: 5%;
                            }
                            li:nth-child(3)::after{
                                content: '';
                                display: block;
                                overflow: hidden;
                                height: 0;
                                clear: both;
                            }
                        }
                    }
                }
            }
            .systemSelfCheck{
                width: 86%;
                height: 22%;
                margin: 0 auto;
                margin-top: 2%;
                min-height: 140px;
                .systemSelfCheck-box{
                    width: 100%;
                    height: 100%;
                    border-radius: 3px;
                    background-color: #F9FCFF;
                    box-sizing: border-box;
                    padding: 15px 20px 20px 40px;
                    .checking{
                        .impTitle{
                            text-align: left;
                            font-size: 21px;
                            color: #0900AA;
                        }
                        .red{color:red;}
                        .checkOk{
                            color: #67C23A;
                        }
                        .imptext{
                            text-align: left;
                            font-size: 16px;
                            margin-top: 10px;
                        }
                    }
                }
            }
            .goExamBox{
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 20%;
                width: 100%;
                // position: relative;
                .upSub{
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    height: 45px;
                    width: 35%;
                    background: rgb(0, 75, 180);
                    color: #FFF;
                    border-radius: 3px;
                    font-size: 18px;
                }
            }
        }
    }
</style>
<style>
    .equipmentInspection .el-dialog{
        width: 400px !important;
        height: 400px;
    }
    .equipmentInspection .el-dialog__body{
        height: 60%;
        padding: 10px !important;
    }
    .equipmentInspection .el-dialog__body .bgRecarding{
        height: 70%;
        width: 100%;
        background-image: url('../../../static/images/rbg.png');
        background-size: 90%;
        background-position: 50% 70%;
        background-repeat: no-repeat;
    }
    .equipmentInspection .el-dialog__body .bgRecarding-ing{
        font-size: 19px;
        text-align: center;
        display: block;
        margin-top: 20px;
    }
    .equipmentInspection .el-dialog__footer .sucRecard{
        background:#1CC966;
        color: #fff;
        padding: 9px !important;
        width: 150px;
    }
    .equipmentInspection .el-dialog .el-dialog__header{
        background: #1D4BB0;
    }
    .imptext .el-link--inner{
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/myExamList/mkfDetection.vue